export const filterButtons = (activeButton) => [
  {
    disabled: activeButton === 'airfilter',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'airfilter',
    text: 'Воздушные',
    id: 26,
  },
  {
    disabled: activeButton === 'oilfilter',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'oilfilter',
    text: 'Масляные',
    id: 30,
  },
  {
    disabled: activeButton === 'fuelfilter',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'fuelfilter',
    text: 'Топливные',
    id: 29,
  },
  {
    disabled: activeButton === 'cabinfilter',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'cabinfilter',
    text: 'Салонные',
    id: 28,
  },
  {
    disabled: activeButton === 'transmissionfilter',
    variant: 'grey-border',
    fontWeight: 'bold',
    dataId: 'transmissionfilter',
    text: 'АКПП',
    id: 32,
  },
];
